<template>
  <div class="form-slider slide">
    <input type="range" tabindex="-1" :style="style" :min="min" :max="max" :step="step" v-model="value" @change="valueUpdate">
  </div>
</template>

<script>
  export default {
    name: 'form-slider',

    props: {
      val: {
        type: Number,
        default: 0
      },

      min: {
        type: Number,
        default: 1
      },

      max: {
        type: Number,
        default: 3
      },

      step: {
        type: Number,
        default: 0.25
      },

      width: {
        type: Number,
        default: 130
      },

      height: {
        type: Number,
        default: 20
      }
    },

    data () {
      return {
        value: 0
      }
    },

    computed: {
      style () {
        let styleStr = ''
        styleStr += 'width: ' + this.width + 'px;'
        styleStr += 'height: ' + this.height + 'px;'
        return styleStr
      }
    },

    methods: {
      valueUpdate: function (e) {
        this.$emit('form-slider-changed', this.value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .slide {
    display: inline;
  }

  input {
    &::-moz-focus-outer {
      border: 0;
    }
    &:focus {
      outline: none;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/inputs/FormSlider.vue